var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _radialGradient2, _radialGradient3, _linearGradient4, _radialGradient4, _linearGradient5, _linearGradient6, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _linearGradient7, _radialGradient18, _radialGradient19, _radialGradient20, _linearGradient8, _linearGradient9, _radialGradient21, _radialGradient22, _radialGradient23, _radialGradient24, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 447.619,
    cy: 133.79,
    gradientTransform: "matrix(.931 0 0 .112 -161.706 412.193)",
    gradientUnits: "userSpaceOnUse",
    r: 258.347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4d8bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0882,
    stopColor: "#f6dcc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    stopColor: "#ffead8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    stopColor: "#fff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.331,
    x2: 478.331,
    y1: 364.869,
    y2: 205.771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1585,
    stopColor: "#e49542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    stopColor: "#e38d39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3795,
    stopColor: "#e07b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4866,
    stopColor: "#df751c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7788,
    stopColor: "#d76818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#d56617"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.228,
    x2: 163.693,
    y1: 380.229,
    y2: 323.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0675,
    stopColor: "#d56617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2868,
    stopColor: "#ce6219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6103,
    stopColor: "#ba5520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#ac4d24"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1314,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2308,
    stopColor: "#e38f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3326,
    stopColor: "#e07c26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#df751c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7018,
    stopColor: "#d96c19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#d56617"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 78.881,
    cy: 394.94,
    gradientTransform: "matrix(.996 -.085 .066 .768 -25.617 98.233)",
    gradientUnits: "userSpaceOnUse",
    r: 44.665,
    xlinkHref: "#lg1"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 122.61,
    cy: 243.194,
    fx: 130.67,
    fy: 219.902,
    gradientTransform: "matrix(-.371 .929 -1.279 -.51 478.964 253.325)",
    gradientUnits: "userSpaceOnUse",
    r: 101.614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1337,
    stopColor: "#ac4d24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3977,
    stopColor: "#c15a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6894,
    stopColor: "#d56617"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.758,
    x2: 314.607,
    y1: 382.208,
    y2: 331.264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3301,
    stopColor: "#d56617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4957,
    stopColor: "#d06318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6812,
    stopColor: "#c35b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8755,
    stopColor: "#ad4d24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8801,
    stopColor: "#ac4d24"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 298.254,
    cy: 252.677,
    gradientTransform: "matrix(.976 -.216 .113 .509 -21.4 188.601)",
    gradientUnits: "userSpaceOnUse",
    r: 129.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#ac4d24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#b55221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#cd611a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8597,
    stopColor: "#d56617"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.925,
    x2: 385.774,
    y1: 387.084,
    y2: 336.14
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    stopColor: "#e28424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6018,
    stopColor: "#e07f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#da721c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8801,
    stopColor: "#d56617"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.335,
    x2: 421.335,
    y1: 423.533,
    y2: 322.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1585,
    stopColor: "#e49542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    stopColor: "#e49441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4437,
    stopColor: "#e3882c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6223,
    stopColor: "#e28424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8875,
    stopColor: "#df771d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9285,
    stopColor: "#df751c"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 256.19,
    cy: 131.086,
    gradientTransform: "matrix(1 0 0 .781 0 28.743)",
    gradientUnits: "userSpaceOnUse",
    r: 208.444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecb780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1624,
    stopColor: "#eab176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3814,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5156,
    stopColor: "#e6a15c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6823,
    stopColor: "#e5974c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8653,
    stopColor: "#e28533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df751c"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 164.405,
    cy: 278.482,
    gradientTransform: "matrix(1 0 0 .889 0 30.805)",
    gradientUnits: "userSpaceOnUse",
    r: 109.538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d56617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#dc7c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5131,
    stopColor: "#e28e3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#e49542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    stopColor: "#e49644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    stopColor: "#e59a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9764,
    stopColor: "#e6a058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7a561"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 7.312,
    cy: 114.92,
    gradientTransform: "matrix(1 0 0 .724 0 31.717)",
    gradientUnits: "userSpaceOnUse",
    r: 61.544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1096,
    stopColor: "#fff9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    stopColor: "#f4d8bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#f1cea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efc89d"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 53.829,
    cy: 83.409,
    gradientUnits: "userSpaceOnUse",
    r: 46.195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4d8bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1027,
    stopColor: "#f2d1af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    stopColor: "#eebe8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5496,
    stopColor: "#e69f54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6272,
    stopColor: "#e49542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7585,
    stopColor: "#e4923d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9212,
    stopColor: "#e3892d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#e28424"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 6.894,
    cy: 158.189,
    gradientTransform: "matrix(-1 0 0 -.66 13.787 262.636)",
    gradientUnits: "userSpaceOnUse",
    r: 75.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efc89d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4095,
    stopColor: "#ecbb87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#e7a561"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 33.582,
    cy: 89.095,
    gradientTransform: "matrix(1 0 0 .783 0 19.381)",
    gradientUnits: "userSpaceOnUse",
    r: 62.552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1096,
    stopColor: "#fff9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6064,
    stopColor: "#f4d8bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7045,
    stopColor: "#f2ceaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8935,
    stopColor: "#eebd8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecb780"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 92.552,
    cy: 161.73,
    gradientTransform: "matrix(.342 -.94 .838 .305 -74.685 199.364)",
    gradientUnits: "userSpaceOnUse",
    r: 91.473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4565,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    stopColor: "#e59645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    stopColor: "#e28424"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 2.133,
    cy: 33.601,
    gradientUnits: "userSpaceOnUse",
    r: 279.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1074,
    stopColor: "#ecb780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2298,
    stopColor: "#e8a16b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3985,
    stopColor: "#e27d47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#d86138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6829,
    stopColor: "#d14c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#ce4529"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 73.231,
    cy: 60.899,
    gradientTransform: "matrix(.707 -.707 .632 .632 -17.052 74.18)",
    gradientUnits: "userSpaceOnUse",
    r: 44.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0991,
    stopColor: "#fbf1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2489,
    stopColor: "#f5d9c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4966,
    stopColor: "#eaaa89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9183,
    stopColor: "#e27d47"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 101.119,
    cy: 77.609,
    gradientUnits: "userSpaceOnUse",
    r: 55.206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#fcedd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3486,
    stopColor: "#f3cfa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#e28424"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 127.754,
    cy: 112.033,
    gradientTransform: "matrix(-.63 -.777 .75 -.608 124.154 279.388)",
    gradientUnits: "userSpaceOnUse",
    r: 32.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b78e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2178,
    stopColor: "#9d7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5189,
    stopColor: "#7f5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7772,
    stopColor: "#6d4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9608,
    stopColor: "#664545"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 0.714,
    cy: 235.16,
    gradientUnits: "userSpaceOnUse",
    r: 238.391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffead8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0182,
    stopColor: "#fce0cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0997,
    stopColor: "#f1b697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    stopColor: "#e8956e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2451,
    stopColor: "#e27d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3044,
    stopColor: "#de6e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3471,
    stopColor: "#dd6938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#dd5d32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd542e"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 14.462,
    cy: 145.162,
    gradientTransform: "matrix(-.961 .005 -.003 -.562 22.866 226.706)",
    gradientUnits: "userSpaceOnUse",
    r: 23.62
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0247,
    stopColor: "#f9cab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#b78681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#9d6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6328,
    stopColor: "#7f5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7767,
    stopColor: "#6d4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#664545"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecb780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#e9ab6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5058,
    stopColor: "#e6a058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6886,
    stopColor: "#e49340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8597,
    stopColor: "#e28424"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 339.097,
    cy: 229.409,
    gradientTransform: "matrix(.703 -.712 .549 .542 -25.035 346.386)",
    gradientUnits: "userSpaceOnUse",
    r: 129.307,
    xlinkHref: "#lg2"
  })), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 304.662,
    cy: 246.567,
    gradientTransform: "matrix(.649 -.761 .616 .526 -44.921 348.709)",
    gradientUnits: "userSpaceOnUse",
    r: 153.986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1103,
    stopColor: "#fbf4c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3449,
    stopColor: "#f0ca91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5276,
    stopColor: "#eaaf6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9087,
    stopColor: "#e28424"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 317.295,
    cy: 394.94,
    gradientTransform: "matrix(.996 -.085 .066 .768 -24.753 118.513)",
    gradientUnits: "userSpaceOnUse",
    r: 44.665,
    xlinkHref: "#lg1"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.39,
    x2: 235.488,
    y1: 394.083,
    y2: 309.422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2734,
    stopColor: "#e28424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3021,
    stopColor: "#e18223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#d56617"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.303,
    x2: 176.303,
    y1: 430.638,
    y2: 348.182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4337,
    stopColor: "#e49542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4464,
    stopColor: "#e49440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6235,
    stopColor: "#e2882c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7411,
    stopColor: "#e28424"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 156.806,
    cy: 402.917,
    gradientTransform: "matrix(.996 -.085 .066 .768 -25.858 106.709)",
    gradientUnits: "userSpaceOnUse",
    r: 44.665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0856,
    stopColor: "#fbeacb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#f0c38f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5058,
    stopColor: "#e6a058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6886,
    stopColor: "#e49340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8597,
    stopColor: "#e28424"
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_29_",
    cx: 184.09,
    cy: 234.355,
    gradientTransform: "matrix(.703 -.712 .549 .542 -73.836 238.363)",
    gradientUnits: "userSpaceOnUse",
    r: 121.639,
    xlinkHref: "#lg2"
  })), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_30_",
    cx: 151.339,
    cy: 256.974,
    gradientTransform: "matrix(.649 -.761 .616 .526 -105.1 237.038)",
    gradientUnits: "userSpaceOnUse",
    r: 115.814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1103,
    stopColor: "#fbf4c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#f6e0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#e9ac6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5706,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6765,
    stopColor: "#e7a35d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7833,
    stopColor: "#e69c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8901,
    stopColor: "#e4913d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9858,
    stopColor: "#e28424"
  }))), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_31_",
    cx: 389.221,
    cy: 400.305,
    gradientTransform: "matrix(.996 -.085 .066 .768 -24.844 125.874)",
    gradientUnits: "userSpaceOnUse",
    r: 44.665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319,
    stopColor: "#fff9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2498,
    stopColor: "#f3cd9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4167,
    stopColor: "#eab072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5007,
    stopColor: "#e7a561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#e6a058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7281,
    stopColor: "#e49340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8597,
    stopColor: "#e28424"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.358 457.58c138.432 0 250.653-13.749 250.653-30.709h-501.306c0 16.961 112.221 30.709 250.653 30.709z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.05 326.195c-8.456-8.456-13.206-19.924-13.206-31.882v-80.108c0-17.044-5.695-33.599-16.182-47.035v133.846c0 11.958 4.75 23.426 13.206 31.882l33.345 33.345c5.161 5.161 13.529 5.161 18.689 0l2.097-2.097z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.12 373.983v52.888h25.833l5.207-46.068 10.302-64.326z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.496 416.557c0-7.453 6.042-13.494 13.494-13.494h10.262c7.453 0 13.494 6.042 13.494 13.494v10.314h-37.25z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.601 194.384c-17.685.485-31.556 15.44-31.556 33.131l.075 146.467 43.315-43.308c13.796-13.793 21.546-32.503 21.546-52.011v-51.823c.001-18.235-15.031-32.959-33.38-32.456z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.188 297.677-26.9 16.663 27.666 43.718-20.266 68.813h30.888l20.417-78.309z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.57 174.701c-26.288.975-47.633 22.534-48.368 48.83-.318 11.397 3.168 21.958 9.265 30.535l-.014.005 43.834 60.27c10.826 14.885 29.814 21.397 47.496 16.288v-105.664c.001-28.415-23.561-51.327-52.213-50.264z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.408 297.677-26.901 16.663 27.667 43.718-20.266 68.813h30.888l20.416-78.309z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.496 314.34 16.816-10.417-3.904-6.246-26.901 16.663 27.667 43.718-20.266 68.813h13.988l20.266-68.813z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.983 208.379c0 39.062 28.293 72.376 66.84 78.7l33.368 5.474c47.366 7.771 95.948 2.79 140.751-14.432l36.24-13.93h28.571c41.184 0 68.894-42.184 52.539-79.981-14.601-33.741-47.852-55.584-84.617-55.584h-193.94c-44.046.001-79.752 35.707-79.752 79.753z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.84 152.512 25.362 22.585-33.247 70.166-4.34 2.883c10.495 18.219 28.022 32.024 49.253 37.47l60.204-57.384c14.206-13.541 22.246-32.31 22.246-51.936v-36.055l-10.857-11.614h-51.725c-22.286 0-42.425 9.15-56.896 23.885z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.544 128.584-22.558 16.454c-1.504 1.097-2.629 2.593-3.288 4.282l79.844 6.863 13.271-30.673z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.205 121.484h-17.966v-23.043c0-9.561 7.751-17.312 17.312-17.312 6.449 0 11.677 5.228 11.677 11.677v17.655c0 6.088-4.935 11.023-11.023 11.023z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.03 152.812-.03 40.897c-.006 8.602 6.98 14.979 14.847 15.1l-.001.009h31.434l.008-.012 34.254-59.485h-79.844c-.43 1.099-.667 2.279-.668 3.491z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.467 74.777h-31.693c-14.554 0-28.575 5.473-39.28 15.333l-20.281 18.68c-3.613 3.328-5.669 8.017-5.669 12.929v6.865h65.939z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.267 123.119c0-26.699-21.644-48.342-48.342-48.342h-4.458c-14.554 0-28.575 5.473-39.28 15.333l-20.281 18.68c-3.613 3.328-5.669 8.017-5.669 12.929v6.865l-22.559 16.454c-2.483 1.812-3.953 4.7-3.955 7.774l-.03 40.897c-.008 10.81 11.025 18.118 20.976 13.893l93.435-39.688c17.687-7.186 30.163-24.528 30.163-44.795z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.088 121.484v-34.574c0-3.02-2.721-5.312-5.697-4.799l-10.189 1.757-16.465-2.402 1.896-4.463c5.818-13.693 19.256-22.585 34.134-22.585h57.902l79.648 74.164v34.559c0 19.917-8.279 38.938-22.855 52.51l-97.612 90.892-39.892-37.146 56.178-114.923z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.202 83.869 2.916-6.865c5.818-13.693 19.256-22.585 34.134-22.585h-17.486c-14.878 0-28.316 8.891-34.134 22.585l-1.896 4.462.435.763c1.612 2.829 4.894 4.259 8.064 3.513z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.834 121.484h-12.688v-23.043c0-9.561 7.751-17.312 17.312-17.312 6.449 0 11.677 5.228 11.677 11.677v12.377c0 9.003-7.298 16.301-16.301 16.301z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.984 119.492h-10.111v-18.362c0-7.619 6.177-13.796 13.796-13.796 5.139 0 9.305 4.166 9.305 9.305v9.863c-.001 7.174-5.816 12.99-12.99 12.99z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.28 208.818 37.324-14.885c12.304-4.907 20.376-16.816 20.376-30.062v-36.249l-6.892-6.138v-21.033l47.113 40.67v52.617c0 13.858-6.03 27.03-16.52 36.085l-53.003 45.754-35.535-30.675c-10.49-9.055-16.52-22.227-16.52-36.085h23.657z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.877 157.735-6.929-8.273c-.617-.736-.093-1.858.867-1.858h16.755c.96 0 1.484 1.121.867 1.858l-6.929 8.273c-1.207 1.442-3.424 1.442-4.631 0z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.79 174.701c-26.288.975-47.633 22.534-48.368 48.83-.318 11.397 3.168 21.958 9.265 30.535l-.014.005 43.834 60.27c10.826 14.885 29.814 21.397 47.496 16.288v-105.664c0-28.415-23.561-51.327-52.213-50.264z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.496 314.34-43.834-60.27.014-.005c-6.096-8.577-9.583-19.138-9.265-30.535.686-24.569 19.367-44.999 43.259-48.371-2.89-.401-5.854-.571-8.88-.459-26.288.975-47.633 22.534-48.368 48.83-.318 11.396 3.168 21.958 9.265 30.535l-.014.005 43.834 60.27c9.786 13.455 26.241 20.066 42.373 17.439-11.152-1.805-21.445-7.898-28.384-17.439z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.404 403.063h10.262c7.453 0 13.494 6.042 13.494 13.494v10.314h-37.25v-10.314c0-7.452 6.042-13.494 13.494-13.494z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.277 368.468.063 58.403h25.833l5.207-46.068 8.632-53.901z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.34 426.871h13.989l-.097-90.013-13.955 31.61z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.209 403.063h10.262c7.453 0 13.494 6.042 13.494 13.494v10.314h-37.25v-10.314c0-7.452 6.042-13.494 13.494-13.494z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.821 194.384c-17.685.485-31.556 15.44-31.556 33.131l.075 146.467 43.315-43.308c13.796-13.793 21.546-32.503 21.546-52.011v-51.823c.001-18.235-15.032-32.959-33.38-32.456z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.253 227.516c0-15.615 10.808-29.091 25.505-32.374-2.547-.562-5.204-.832-7.937-.757-17.685.485-31.556 15.44-31.556 33.132l.075 146.467 13.981-13.979z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.624 403.063h10.262c7.453 0 13.494 6.042 13.494 13.494v10.314h-37.25v-10.314c0-7.452 6.041-13.494 13.494-13.494z",
    fill: "url(#SVGID_31_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLion);
export default __webpack_public_path__ + "static/media/icon-lion.63245d24686d7fadd96f98a08f927fbe.svg";
export { ForwardRef as ReactComponent };